interface GoogleLoginRequest {
  code: string;
  remember_me: boolean;
}

interface LoginResponse {
  access_token: string;
  expires_at: number;
  user: {
    id: number;
    username: string;
    display_name: string;
    is_admin: boolean;
  };
}

interface RefreshResponse {
  access_token: string;
  expires_at: number;
}

interface MeResponse {
  id: number;
  username: string;
  display_name: string;
  is_admin: boolean;
}

export async function loginWithGoogle(
  code: string,
  rememberMe: boolean
): Promise<LoginResponse> {
  const body: GoogleLoginRequest = {
    code,
    remember_me: rememberMe,
  };

  const res = await fetch('/api/auth/google', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  });

  if (!res.ok) {
    if (res.status === 403) {
      throw new Error('This Google account is not authorized for this library');
    }
    if (res.status === 401) {
      throw new Error('Google sign-in failed');
    }
    throw new Error(`Login failed: ${res.status}`);
  }

  return res.json();
}

export async function refreshToken(): Promise<RefreshResponse | null> {
  const res = await fetch('/api/auth/refresh', {
    method: 'POST',
    credentials: 'include',
  });

  if (!res.ok) {
    return null;
  }

  return res.json();
}

export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
  });
}

export async function getCurrentUser(accessToken: string): Promise<MeResponse> {
  const res = await fetch('/api/auth/me', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!res.ok) {
    throw new Error('Failed to get current user');
  }

  return res.json();
}
